import React, {Component} from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { Helmet } from 'react-helmet'
import * as ACTIONS from '../actions/Page'
import { TweenLite, Power4 } from "gsap"
import ScrollToPlugin from "gsap/ScrollToPlugin";

import { 
  NavLink,
  withRouter
} from 'react-router-dom';

import { Blocks, Grid } from '../components';

const mapStateToProps = state => ({
  page: state.page.data,
  loading: state.page.loading
})

const mapDispatchToProps = (dispatch) => {
  return{
    fetchPage: bindActionCreators(ACTIONS.getPage, dispatch),
  }
  
}

class Page extends Component {

  constructor(props) {
    super(props);

    this.state = {}

    

  }
 
 componentDidMount() {    
  this.props.fetchPage("home");
 }


 componentWillMount() {}


render () {

  let { page,loading } = this.props;

  if(loading) return null;

  const mods = page.acf.template.toLowerCase();

  return(

      <div className={"Template  Template--home"}>

        <Helmet>
          <title> Mancoba </title>
        </Helmet>

        <div className={"Template-head Template-head--"+page.acf.title_position.toLowerCase()}>
          <h1 className="Template-title">Estate Ferlov Mancoba</h1>
        </div>

        <div className="Template-blocks">
          {page.acf.blocks && <Blocks  blocks={page.acf.blocks} location={this.props.location.pathname.replace("/", "") } />}
        </div>


  
      </div>  

       

    );

  
    

  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page));



// WEBPACK FOOTER //
// ./src/js/templates/home.js